// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 2737) return "static/chunks/mui-604102b8c54a65ff.js";
	if (chunkId === 1229) return "static/chunks/1229-1f492e1109f06ad2.js";
	if (chunkId === 9501) return "static/chunks/9501-0becb363da0bf5b7.js";
	if (chunkId === 9146) return "static/chunks/9146-c36adc42f66e1a31.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"7538":"recorder","9983":"profiler"}[chunkId] || chunkId) + "." + {"526":"8a2db899e720407e","2029":"d6695687b22e43eb","4878":"2254d9995bc9a3af","7538":"1322f0e63ceff47c","9421":"1b622925f5d10dfd","9983":"f7ac861f12387ae8"}[chunkId] + ".js";
};